import React from 'react';
import tpl from '../templates/cash_proceeds';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        };
    }

    static displayName = 'CashProceeds.Views.Main';
}
